import PropTypes from 'prop-types';

import VideoIconProgress from './VideoIconProgress/VideoIconProgress';
import CoevaluationIconProgress from './CoevaluationIconProgress/CoevaluationIconProgress';
import QuizIconProgress from './QuizIconProgress/QuizIconProgress';
import LessonIconProgress from './LessonIconProgress/LessonIconProgress';
import AditionalMaterialLesson from './AditionalMaterialLesson/AditionalMaterialLesson';
import SummaryIcon from './SummaryIcon/SummaryIcon';
import AudioIconProgress from './AudioIconProgress/AudioIconProgress';

import classes from './LessonInfo.module.css';

const LessonInfo = props => {
  // console.log('🚀 ~ props:', props.data.idRepository);
  return (
    <div
      className={`${classes.productLessonContainer} ${
        !props.accessCourse ? classes.productLessonDisabled : ''
      }`}
    >
      <aside className={classes.lessonDescription}>
        {props.data.idRepository === 6 ? (
          <LessonIconProgress
            userTrack={props.userTrack}
            data={props.data}
            accessCourse={props.accessCourse}
          />
        ) : (
          <VideoIconProgress
            userTrack={props.userTrack}
            data={props.data}
            accessCourse={props.accessCourse}
          />
        )}

        {props.data.pathAudio && (
          <AudioIconProgress
            userTrack={props.userTrack}
            data={props.data}
            accessCourse={props.accessCourse}
          />
        )}
        {props.data.pathSummary && (
          <SummaryIcon summary={props.data.pathSummary} />
        )}
        <CoevaluationIconProgress
          userTrack={props.userTrack}
          data={props.data}
          accessCourse={props.accessCourse}
        />
        <QuizIconProgress
          userTrack={props.userTrack}
          data={props.data}
          accessCourse={props.accessCourse}
        />
      </aside>
      <AditionalMaterialLesson lessonMaterial={props.data} />
    </div>
  );
};

LessonInfo.propTypes = {
  // eslint-disable-next-line react/require-default-props
  data: PropTypes.object,
  // eslint-disable-next-line react/require-default-props
  accessCourse: PropTypes.bool,
  // eslint-disable-next-line react/require-default-props
  userTrack: PropTypes.object
};

export default LessonInfo;
